module.exports = __webpack_public_path__ + "static/img/malvestida-magazine-u79wy47kvVs-unsplash_thumb.08ff73c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/malvestida-magazine-u79wy47kvVs-unsplash_thumb.png
// module id = K/DY
// module chunks = 4